import PropTypes from 'prop-types';

export default function PdfLinks ({ value }) {
  const pdfLinks = value ? JSON.parse(value) : [];
  const pdfListItems = pdfLinks.map((item) => {
    return (
      <li key={item.type}>
        <b>{item.type}</b>: <a href={item.url}>{item.url}</a>
      </li>
    );
  });
  // Read Only is used for inputs that will NEVER be enabled,
  // Disabled is used for inputs that are temporarily disabled.
  return (
    <div>
      <ul>
        {pdfListItems}
      </ul>
    </div>
  );
}

PdfLinks.propTypes = {
  value: PropTypes.string,
};
